import {
  Autocomplete,
  Box,
  Breadcrumbs,
  Button,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { ArrowForwardIos } from "@mui/icons-material";
import {
  calculateTotals,
  columnGroupingModel,
  // computedColumns,
  createInitialTotals,
  PL_LEVELS,
} from "./Action";
import {
  Dept_Brcls_AttriApi,
  StockSetupTemplate_GetrowApi,
  StockSetupTemplate_UpdateApi,
} from "../../Server/ApiV2";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  getUniqueValues,
} from "../../Utility/Utilitys";
import { DataGridPro } from "@mui/x-data-grid-pro";
import AutocompleteCheckboxFixSizeUid from "./AutocompleteCheckboxFixSizeUid";
import { exportToExcel } from "../ItemApprove/ItemApproveRequestAction";
import IntegerEditCell from "./components/IntegerEditCell";
import AutocompleteCheckboxFixSizeUidA1 from "./components/AutocompleteCheckboxFixSizeUidA1";
import { createMultiSelectOperator } from "../../Component/Common/ReuseableComponent/DatagridFilterColumnComp";

const StockSetupTemplate = () => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const [arriData, setArriData] = useState([]);
  const [gridData, setGridData] = useState([]);

  const [filterObj, setFilterObj] = useState({
    branch: "",
    dept: "",
  });

  const fGetrow = async () => {
   try{
  const resp = await Dept_Brcls_AttriApi();
      if (resp?.status === 200) {
        setArriData(resp?.data);

           const department = resp?.data?.Department.map((x) => x.Cd);
           const branch = resp?.data?.BrClassification.map((x) => x.UId);
      setFilterObj((prev) => ({
        ...prev,
        branch: branch,
        dept:department,
      }));
      return  {branch , department}; 
      } else {
        setArriData([]);
      }
   }catch (error) {}
    
    return [];
  };

const fLoad = async ({ branch, department }) => {
  try {
    const sBranch = branch ?? filterObj.branch ?? [];
    const sDept = department ?? filterObj.dept ?? [];
    let FinalObj = fcheck_null_undefine_replace_empty({
      MainGrp: sDept.toString(),
      BrClassification: sBranch.toString(),
    });

    const resp = await StockSetupTemplate_GetrowApi(FinalObj);

    if (resp?.status === 200) {
      const GridID = resp?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridData(GridID);
    } else {
      setGridData([]);
    }
  } catch (error) {
    console.error(error);
  }
};


  // helper – put this above fSave
  const validatePlMinMax = (rows) => {
    const errors = [];
    rows.forEach((row) => {
      PL_LEVELS.forEach((num) => {
        const pl = `PL${num.toString().padStart(2, "0")}`;
        const minVal = Number(row[`${pl}_Min`] ?? 0);
        const maxVal = Number(row[`${pl}_Max`] ?? 0);
        if (minVal > maxVal) {
          errors.push({
            row,
            pl,
            minVal,
            maxVal,
          });
        }
      });
    });

    return errors;
  };

  const fSave = async () => {
    try {
      const editedRows = gridData?.filter((row) => row.IsRowEdited === true);
      if (editedRows.length === 0) {
        fAlertToast(
          "WARNING",
          "No updates detected. Please edit a row before saving."
        );
        return;
      }
      const validationErrors = validatePlMinMax(editedRows);
      if (validationErrors.length > 0) {
        const { row, pl, minVal, maxVal } = validationErrors[0];
        fAlertToast(
          "WARNING",
          `In ${row?.GrpName} ${pl}: Min (${minVal}) cannot be greater than Max (${maxVal})`
        );
        return;
      }
      const detail = editedRows?.map((item) => {
        const detailItem = {};
        PL_LEVELS.forEach((num) => {
          const pl = `PL${num.toString().padStart(2, "0")}`;
          detailItem[`${pl}_Max`] = item[`${pl}_Max`] ?? 0;
          detailItem[`${pl}_Min`] = item[`${pl}_Min`] ?? 0;
        });
        return {
          BrClassification: item.BrClasification,
          Grp: item.Grp,
          ...detailItem,
        };
      });
      let FinalObj = fcheck_null_undefine_replace_empty({ detail });
      const resp = await StockSetupTemplate_UpdateApi(FinalObj);
      if (resp?.status === 200) {
        fAlertToast("SUCCESS", "Data saved successfully");
       // fLoad();
      }
    } catch (error) {}
  };

useEffect(() => {
  const init = async () => {
    const rowData = await fGetrow();   // { branch, department }
    if (!rowData) return;
    await fLoad(rowData);
  };
  init();
}, []);


  // useEffect(() => {
  //   if (
  //     arriData?.Department?.length > 0 &&
  //     arriData?.BrClassification?.length > 0
  //   ) 
  //   {
  //     setFilterObj((prev) => ({
  //       ...prev,
  //       dept: arriData.Department.map((d) => d.Cd),
  //       branch: arriData.BrClassification.map((b) => b.UId),
  //     }));
     
  //   }
  // }, [arriData]);

  console.log(arriData);

  const breadCrumbStyle = {
    color: "#cccccc",
    fontSize: "0.9rem",
    textDecoration: "underline",
  };

  const breadCrumbActiveStyle = {
    color: "#0288d1",
    fontSize: "0.9rem",
    textDecoration: "underline",
  };

  const isPlField = (field) =>
    PL_LEVELS.some((num) => {
      const pl = `PL${num.toString().padStart(2, "0")}`;
      return field === `${pl}_Max` || field === `${pl}_Min`;
    });


  const uniqueCategoryValues = getUniqueValues(gridData, "GrpName");
  const uniqueClassificationValues = getUniqueValues(gridData, "BrClasificationName");
  const uniqueMainGrpValues = getUniqueValues(gridData, "mainGroupName");
  const uniqueSubGrpValues = getUniqueValues(gridData, "subCategoryName");

  const computedColumns = [
    {
      field: "GrpName",
      headerName: "Category",
      width: 160,
      headerAlign: "left",
      align: "left",
      filterOperators: [createMultiSelectOperator(uniqueCategoryValues)],
    },
    {
      field: "BrClasificationName",
      headerName: "Classification",
      width: 120,
      headerAlign: "left",
      align: "left",
      filterOperators: [createMultiSelectOperator(uniqueClassificationValues)],
    },

    // Auto-generate all PL Max/Min columns
    ...PL_LEVELS.flatMap((num) => {
      const pl = `PL${num.toString().padStart(2, "0")}`;
      return [
        {
          field: `${pl}_Max`,
          headerName: `Max`,
          width: 70,
          headerAlign: "center",
          align: "center",
          cellClassName: "editable-cell",
        },
        {
          field: `${pl}_Min`,
          headerName: `Min`,
          width: 70,
          headerAlign: "center",
          align: "center",
          cellClassName: "editable-cell",
        },
      ];
    }),

    {
      field: "subCategoryName",
      headerName: "Sub Group",
      width: 180,
      headerAlign: "left",
      align: "left",
      filterOperators: [createMultiSelectOperator(uniqueSubGrpValues)],
    },
    {
      field: "mainGroupName",
      headerName: "Main Group",
      width: 180,
      headerAlign: "left",
      align: "left",
      filterOperators: [createMultiSelectOperator(uniqueMainGrpValues)],
    },
  ];

  const columns = React.useMemo(
    () =>
      computedColumns.map((col) =>
        isPlField(col.field)
          ? {
              ...col,
              renderCell: (params) => (
                <IntegerEditCell
                  key={`${params.id}-${params.field}`}
                  value={params.row[params.field]}
                  onValueChange={(newValue) => {
                    setGridData((prev) =>
                      prev.map((row) =>
                        row.id === params.id
                          ? {
                              ...row,
                              [params.field]: newValue,
                              IsRowEdited: true, // <- set here
                            }
                          : row
                      )
                    );
                  }}
                />
              ),
            }
          : { ...col }
      ),
    [
      setGridData,
      uniqueCategoryValues,
      uniqueClassificationValues,
      uniqueMainGrpValues,
      uniqueSubGrpValues,
    ]
  );

  return (
    <Box p={vMediaQuery ? 1 : 2}>
      <Box sx={{ mb: 2 }}>
        <span style={breadCrumbStyle}>Masters </span>{" "}
        <ArrowForwardIos color="info" style={{ marginRight: "0.5rem" }} />
        <span style={breadCrumbActiveStyle}>Stock Setup Template</span>
      </Box>
      <Grid container spacing={{ xs: 1, sm: 2 }} my={1}>
        <Grid item xs={12} sm={6} md={3.5}>
          <AutocompleteCheckboxFixSizeUidA1
            label={"Classification"}
            options={arriData?.BrClassification ?? []}
            xValue={filterObj?.branch}
            xtabIndex={"Classification"}
            setValue={setFilterObj}
            objName="branch" // ✅ FIXED
            autoComplete="off"
            placeholder="Search Classification"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4.5}>
          <AutocompleteCheckboxFixSizeUid
            label={"Department"}
            options={arriData?.Department ?? []}
            xValue={filterObj?.dept}
            xtabIndex={"Department"}
            setValue={setFilterObj}
            objName="dept"
            autoComplete="off"
            placeholder="Search Department"
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={8}
          md={4}
          gap={1}
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
        >
          <Button variant="contained" size="small" onClick={()=>fLoad(filterObj.branch , filterObj.dept)}>
            Load
          </Button>

          <Button
            variant="contained"
            size="small"
            color="success"
            onClick={fSave}
          >
            Save
          </Button>

          <Tooltip title="Export CSV">
            <IconButton
              color="primary"
              onClick={() =>
                exportToExcel(
                  gridData,
                  "StockSetupTemplate",
                  "StockSetupTemplate"
                )
              }
              size="small"
            >
              <DownloadOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
      <Box
        sx={{
          height: { xs: "65vh", sm: "70vh", md: "78vh" },
          overflowY: "auto",
        }}
      >
        <DataGridPro
          rowHeight={30}
          headerHeight={35}
          rows={gridData ?? []}
          columns={columns}
          columnGroupingModel={columnGroupingModel}
          experimentalFeatures={{ columnGrouping: true }}
          getRowId={(row) => row.id}
          initialState={{
            pinnedColumns: !vMediaQuery
              ? { left: ["GrpName", "BrClasificationName"] }
              : {},
          }}
          sx={{
            "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
              color: "#24292e",
            },
            "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root.Mui-checked":
              {
                color: "#0298f5",
              },
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },

            "& .MuiDataGrid-cell": {
              padding: "0px 2px",
              fontSize: "11px",
            },
            "& .total-summary-row .MuiDataGrid-cell": {
              backgroundColor: "#ebececff",
              fontWeight: "bold",
              //  border: "2px solid #1976d2",
            },
            "& .editable-cell": {
              backgroundColor: "#edfaff",
              border: " 1px solid lightgray",
            },
            // highlight input while editing
            "& .MuiDataGrid-cell--editing": {
              backgroundColor: "#d7edff",
            },
            "& .MuiDataGrid-cell--editing .MuiInputBase-root": {
              backgroundColor: "#d7edff",
              borderRadius: 1,
            },
            "& .MuiDataGrid-columnHeader": {
              whiteSpace: "normal",
              lineHeight: "1.2em",
              paddingTop: "6px",
              paddingBottom: "1px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "normal",
              wordWrap: "break-word",
              fontSize: "11px !important", // Optional for better fit
            },
            "& .MuiDataGrid-columnHeaders, & .MuiDataGrid-pinnedColumnHeaders":
              {
                backgroundColor: "#0d73bb",
                color: "#fff",
              },
            "& .MuiDataGrid-pinnedColumnHeaders": {
              zIndex: 2,
              textAlign: "left",
            },
            "& .MuiDataGrid-pinnedColumns--left": {
              boxShadow: "4px 0 6px -4px rgba(37, 15, 15, 0.2)",
            },
            "& .MuiDataGrid-pinnedRows": {
              backgroundColor: "#e3f2fd",
              fontWeight: "bold",
            },
            "& .MuiDataGrid-row--pinned": {
              backgroundColor: "#e3f2fd",
              fontWeight: "bold",
            },
          }}
          hideFooter
        />
      </Box>
    </Box>
  );
};

export default StockSetupTemplate;
